import script from "./ow-clients-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-clients-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-clients-form.vue?vue&type=style&index=0&id=7562893d&lang=scss"
import "./ow-clients-form.vue?vue&type=style&index=1&id=7562893d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7562893d"]])

export default __exports__